/**
 * Created by USER on 18/10/9.
 */
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import {message} from 'antd';
import {changeBarState} from '../redux/actions/headerbar_action';
import httpClient from '../swagger/swagger';
import {getAnnouncement, getSingleAnnouncement} from '../redux/actions/announcement_action';
import ImageList from '../images/img';

const { client } = httpClient;

class Announcement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkPage: 1,
      totalPage: 1,
      announcementData: [],
      content: {
        title: '',
        author_name: '',
        date_updated: '',
        category_name: ''
      },
      announcementId: 15,
      showWechatQrCode: 'none'
    }
  }

  componentWillMount() {
    this.props.dispatch(changeBarState('announcement'));
    this.getAnnoumcementList(1);
    const noticeId = this.getQueryString('Notice_id');
    if (noticeId) { // url是否有公告的id
      this.getAnnoumcementContent(noticeId);
    }
  }

  componentDidMount() {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 500);
  }

  getAnnoumcementList(page) { // 请求公告的列表
    const {content} = this.state;
    client.then((oclient) => {
      oclient.apis.bulletin.get_bulletins_language({
        language: this.props.t('language'),
        limit: 6,
        page,
      }).then((res) => {
        const data = res.obj;
        if (data.code === 200) {
          this.setState({
            totalPage: data.total_page,
            announcementData: data.data
          });
          this.props.dispatch(getAnnouncement(data));
          const noticeId = this.getQueryString('Notice_id'); // 如果url没有参数时，默认显示第一条内容
          if (!noticeId && content.title === '' && data.data.length > 0) {
            this.getAnnoumcementContent((data.data)[0].id);
          }
        } else {
          message.error(data.message)
        }
      }).catch(() => message.error(this.props.t('request_error')));
    }).catch(() => message.error(this.props.t('request_error')));
  }

  getQueryString(name) { // 获取url的指定参数
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    const r = this.props.location.search.substr(1).match(reg);
    if (r != null) {
      return r[2];
    }
    return null;
  }

  getAnnoumcementContent(id) { // 请求单挑公告的内容
    this.setState({
      announcementId: id
    });
    client.then((oclient) => {
      oclient.apis.bulletin.get_bulletin_language_bulletin_id({
        language: this.props.t('language'),
        bulletin_id: id
      }).then((res) => {
        const data = res.obj;
        if (data.code === 200) {
          this.setState({
            content: data.data
          });
          this.props.dispatch(getSingleAnnouncement(data.data))
        } else {
          message.error(data.message)
        }
      }).catch(() => message.error(this.props.t('request_error')));
    }).catch(() => message.error(this.props.t('request_error')));
  }

  checkAnnouncement(id) { // 切换公告判断设备的大小从而去判断是否打开新的页面
    const {offsetWidth} = document.body;
    if (offsetWidth > 768) {
      this.props.history.push(`/announcement?Notice_id=${id}`);
      this.getAnnoumcementContent(id);
    } else {
      this.props.history.push(`/announcement_detail?Notice_id=${id}`);
    }
  }

  prevPage() { //  公告翻页
    const {checkPage} = this.state;
    if (checkPage > 1) {
      this.getAnnoumcementList(checkPage - 1)
      this.setState({
        checkPage: checkPage - 1
      })
    }
  }

  nextPage() { // 公告翻页
    const {checkPage, totalPage} = this.state;
    if (checkPage < totalPage) {
      this.getAnnoumcementList(checkPage + 1);
      this.setState({
        checkPage: checkPage + 1
      })
    }
  }

  componentWillReceiveProps(nextProps){ // 根据状态不同来执行操作
    if (this.props.appBarReducer.language !== nextProps.appBarReducer.language) {
      const {announcementId, checkPage} = this.state;
      this.getAnnoumcementContent(announcementId);
      this.getAnnoumcementList(checkPage);
    }
  }

  showQrCode() { // 二维码显示
    this.setState({
      showWechatQrCode: 'block'
    });
  }

  hideQrCode() { // 二维码隐藏
    this.setState({
      showWechatQrCode: 'none'
    });
  }

  clickWechatIcon() { // 鼠标点击微信二维码
    if (this.state.showWechatQrCode === 'none') {
      this.setState({
        showWechatQrCode: 'block'
      });
    }
  }

  goToWeibo() { // 打开公司微博
    window.open('https://weibo.com/6543415870/profile?rightmod=1&wvr=6&mod=personinfo&is_all=1');
  }

  render() {
    const {t} = this.props;
    const {checkPage, totalPage, announcementId} = this.state;
    const {announcement, singleAnnouncement} = this.props.announcementReducer;
    return (
      <div className="announcement">
        <div className="announcement_list">
          <div className="announcement_list_title">
            <span>{t('announcement')}</span>
            <div className="paging">
              <i
                className="icon iconfont icon-ArtboardCopy1"
                onClick={() => this.prevPage()}
              />
              <span>{checkPage} / {totalPage}</span>
              <i
                className="icon iconfont icon-ArtboardCopy"
                onClick={() => this.nextPage()}
              />
            </div>
          </div>
          {
            announcement.data.map((item) => (
              <div
                className={`single_announcement_title ${(announcementId == item.id) ? 'single_announcement_active': ''}`}
                onClick={() => this.checkAnnouncement(item.id)}
                key={item.id}
              >
                <p>
                  {item.title}
                </p>
                <span>{/\d{4}-\d{1,2}-\d{1,2}/g.exec(item.date_updated)}</span>
              </div>
            ))
          }
        </div>
        <div className="announcement_content">
          <div className="announcement_content_title">{singleAnnouncement.title === '' ? '' : `${singleAnnouncement.title}`}</div>
          <div
            dangerouslySetInnerHTML={{__html: singleAnnouncement.content}}
          >
          </div>
          <div className="announcement_author">
            <span>{singleAnnouncement.category_name}</span>
            <span>{singleAnnouncement.date_updated}</span>
          </div>
          <div className="announcement_community">
            <p className="announcement_community_title">LUBANSO {t('community')}</p>
            <ul>
              <li>
                <span>Telegram:</span>
                <a href="https://t.me/lubanso" target="_blank">https://t.me/lubanso</a>
              </li>
              <li>
                <span>Facebook:</span>
                <a href="https://www.facebook.com/LUBANSO" target="_blank">https://www.facebook.com/LUBANSO</a>
              </li>
              <li>
                <span>Twitter:</span>
                <a href="https://twitter.com/LUBANSO" target="_blank">https://twitter.com/LUBANSO</a>
              </li>
            </ul>
            <div className="contact_us announcement_contact_us">
              <span
                className="icon iconfont icon-weibo"
                onClick={() => this.goToWeibo()}
                onKeyPress={() => this.goToWeibo()}
              />
              <span
                className="icon iconfont icon-wechat"
                onMouseOver={() => this.showQrCode()}
                onMouseOut={() => this.hideQrCode()}
                onClick={() => this.clickWechatIcon()}
                onKeyPress={() => this.clickWechatIcon()}
              >
                <div
                  className="img_qrocde"
                  style={{display: this.state.showWechatQrCode}}
                 >
                  <img src={ImageList.img.wechatQrCode} alt="LUBANSO" />
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


function select(state) {
  return {
    appBarReducer: state.appBarReducer,
    announcementReducer: state.announcementReducer
  };
}

const AnnouncementConnected = connect(select)(Announcement);

export default translate('translations')(AnnouncementConnected);